import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';

import { SharedModule } from '../shared/shared.module';

import { StageService } from '../stage/services/stage.service';
import { StageSandbox } from '../stage/services/stage.sandbox';

import { StageEffects } from '../stage/effects/stage.effect';

import { StageContainerComponent } from './containers/stage-container/stage-container.component';
// import { DashboardContainerComponent } from './containers/dashboard-container/dashboard-container.component';
import { DynamicComponent } from './components/dynamic/dynamic.component';

import { BlockUIModule, BlockUIService } from 'ng-block-ui';
import { BaseFileTypeComponent } from './components/base-file-type/base-file-type.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BlockUIModule,
    EffectsModule.run(StageEffects),
    SharedModule
  ],
  declarations: [
    StageContainerComponent,
    DynamicComponent,
    BaseFileTypeComponent,
    // DashboardContainerComponent
  ],
  exports: [
    StageContainerComponent,
    // DashboardContainerComponent
  ],
  providers: [
    StageService,
    StageSandbox,
    BlockUIService
  ]
})
export class StageModule { }



// WEBPACK FOOTER //
// ./src/app/stage/stage.module.ts